import type { CheckpointModel } from '@/types/models/CheckpointModel'
import { type EventModel } from '@/types/models/EventModel'
import type { EDateFieldLimit, EDateLimit } from '@rfc/rfc-components-library/types'
import type { AssociatedDeviceModel } from '../models/DeviceModel'

export type EventFilters = Partial<EventModel>
export type EventQueryFilters = {
    event_id?: Partial<EventModel>
    checkpoint_id?: Partial<CheckpointModel>
}

export type EventQueryResponse = {
    event_id: EventModel
    checkpoint_id: CheckpointModel
    checkpoints: CheckpointModel[]
    devices: AssociatedDeviceModel[]
}

export const defaultEventFilters: EventFilters = {
    start_at: undefined,
    end_at: undefined
}

export type DateLimitFilters = {
    period: EDateLimit
    field: EDateFieldLimit.START_AT | EDateFieldLimit.END_AT
}

export type AdvancedEventFilters = {
    finished?: 0 | 1
    ongoing?: 0 | 1
    upcoming?: 0 | 1
}

export const advancedEventFiltersKeys = ['ongoing', 'upcoming', 'finished']

export const defaultAdvancedEventFilters: AdvancedEventFilters = {
    ongoing: 1,
    upcoming: 1
}
